import { groupBy, map } from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import {
  getCareTeam,
  getCaseloadCarePlans,
  getFormsySubmissionsForMultiple,
  getMyCaseload,
  getUnsignedWorkerEncounters,
} from "../components/services/soar";
import {
  get4DaysAgo,
  getFieldDate,
  getFieldName,
  getFieldText,
} from "../scripts/helperScripts";
import ClientCard from "./common/ClientCard";
import FamilyChartModal from "./common/FamilyChartModal";
import SearchBox from "./common/SearchBox";

const MyCaseload = () => {
  const [programs, setPrograms] = useState([]);
  const [clients, setClients] = useState({});
  const [careplans, setCarePlans] = useState([]);
  const [encounters, setEncounters] = useState([]);
  const [history, setHistory] = useState([]);
  const isMountedRef = useRef(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [discharged, setDischarged] = useState(false);
  const [familyChart, setFamilyChart] = useState();
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));

  //Route Access Protection
  // useEffect(() => {
  //   if (safyInfo) {
  //     const modules = safyInfo.user.modules;
  //     if (
  //       modules.includes("My Caseload") === false &&
  //       modules.includes("Team Caseload") === false
  //     ) {
  //       navigate("/");
  //     }
  //   } else navigate("/");
  // });

  useEffect(() => {
    if (safyInfo !== null) {
      const toastId = toast.loading(
        `Getting caseload for ${safyInfo.user.displayName}...`,
        { type: toast.TYPE.INFO }
      );

      // get Caseload for user
      getMyCaseload(safyInfo.user.email).then((response) => {
        if (response && isMountedRef.current) {
          const gracePeriod = get4DaysAgo();
          const records = response.filter(
            (program) =>
              program["care.ccx_expdate"] === undefined ||
              program.ccx_dischargedate !== undefined ||
              (program.ccx_dischargedate === undefined &&
                new Date(getFieldDate(program["care.ccx_expdate"])) >
                  gracePeriod)
          );
          setPrograms(records);
          let filtered = records;
          filtered = filtered.filter(
            (program) =>
              program.ccx_dischargedate === undefined &&
              (safyInfo.user.safyInfo.BusinessUnitIdName === "ccplive" ||
                getFieldName(program.ccx_company) ===
                  safyInfo.user.safyInfo.BusinessUnitIdName)
          );
          // if (!oldCareTeam) {
          //   filtered = filtered.filter(
          //     (program) => program["care.ccx_expdate"] === undefined
          //   );
          // }

          filtered = filtered.sort((a, b) =>
            a["con.fullname"].localeCompare(b["con.fullname"])
          );

          const grouped = groupBy(filtered, "con.contactid");
          setClients(grouped);

          getFormsySubmissionsForMultiple(
            records.map((c) => c.ccx_patient["#text"])
          ).then((response) => {
            if (response && isMountedRef.current) {
              setHistory(response);
            }
          });
          toast.update(toastId, {
            render: `Caseload for ${safyInfo.user.displayName} loaded.`,
            type: toast.TYPE.SUCCESS,
            isLoading: false,
            autoClose: 5000,
            closeOnClick: true,
          });
        } else {
          toast.dismiss(toastId);
        }
      });
    } else {
      setClients([]);
    }

    //get Care Plans for Caseload
    if (safyInfo !== null && safyInfo.user.safyInfo.ADUser) {
      getCaseloadCarePlans(safyInfo.user.safyInfo.ADUser).then((response) => {
        if (response && isMountedRef.current) {
          setCarePlans(response);
        }
      });
    } else {
      setCarePlans([]);
    }

    document.title = "SAFY Portal - My Caseload";

    return () => {
      document.title = "SAFY Portal";
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (safyInfo) {
      getUnsignedWorkerEncounters(
        safyInfo.user.safyInfo.SOARUserId,
        safyInfo.user.safyInfo.BusinessUnitIdName
      ).then((response) => {
        if (response && isMountedRef.current) {
          setEncounters(
            JSON.parse(response).resultset.result.filter(
              (enc) => enc.ccx_draftsigned["@name"] === "No"
            )
          );
        }
      });
    }

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // //Unsigned Encounters
  // useEffect(() => {
  //   if (safyInfo) {
  //     getUnsignedWorkerEncounters(
  //       safyInfo.user.safyInfo.SOARUserId,
  //       safyInfo.user.safyInfo.BusinessUnitIdName
  //     ).then((response) => {
  //       if (response && isMountedRef.current) {
  //         setEncouters(JSON.parse(response).resultset.result);
  //       }
  //     });
  //   }

  //   return () => {
  //     isMountedRef.current = false;
  //   };
  // }, []);

  const handleSearch = ({ currentTarget: input }) => {
    setSearchQuery(input.value);
    filterPrograms(input.value, discharged);
  };

  const handleDischarged = (value) => {
    console.log("Discharged Value: ", value);
    setDischarged(value);
    filterPrograms(searchQuery, value);
  };

  // const handleOldCareTeam = (value) => {
  //   console.log("Old Care Team value: ", value);
  //   setOldCareTeam(value);
  //   filterPrograms(searchQuery, discharged);
  // };

  const filterPrograms = (search, discharge) => {
    console.log("Filter", search, discharge);
    let filtered = programs;
    if (search) {
      filtered = filtered.filter((program) =>
        program["con.fullname"]
          .toLowerCase()
          .includes(search.toLocaleLowerCase())
      );
    }
    if (discharge === false) {
      filtered = filtered.filter(
        (program) => program.ccx_dischargedate === undefined
      );
    } else {
      filtered = filtered.filter(
        (program) =>
          new Date(getFieldDate(program.ccx_administrativeclosedate)) >
            new Date() || program.ccx_administrativeclosedate === undefined
      );
    }
    // if (careTeam === false) {
    //   filtered = filtered.filter(
    //     (program) => program["care.ccx_expdate"] === undefined
    //   );
    // }

    filtered = filtered.sort((a, b) =>
      a["con.fullname"].localeCompare(b["con.fullname"])
    );

    const grouped = groupBy(filtered, "con.contactid");

    setClients(grouped);
  };

  const handleFamilyChartClick = async (clientProgram) => {
    const response = await getCareTeam(clientProgram["con.contactid"]);
    if (isMountedRef.current) {
      if (response) {
        const collaterals = response.filter(
          (collateral) =>
            getFieldText(collateral.ccx_membertype) === "803080001" &&
            (!collateral.ccx_expdate ||
              moment(getFieldText(collateral.ccx_expdate)).isSameOrAfter(
                moment()
              ))
        );
        const children = collaterals.filter(
          (collateral) =>
            getFieldText(collateral.sor_contactrole) === "186460001"
        );
        children.sort((a, b) => {
          if (a.ccx_name > b.ccx_name) return 1;
          if (a.ccx_name < b.ccx_name) return -1;
          return 0;
        });
        const other = collaterals.filter(
          (collateral) =>
            getFieldText(collateral.sor_contactrole) === "186460009"
        );
        other.sort((a, b) => {
          if (a.ccx_name > b.ccx_name) return 1;
          else if (a.ccx_name < b.ccx_name) return -1;
          return 0;
        });

        setFamilyChart({
          clientName: clientProgram["con.fullname"],
          children,
          other,
        });
      }
    }
  };

  //Render UI
  return (
    <>
      <h1>{safyInfo !== null && safyInfo.user.displayName}</h1>
      <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 mb-4">
        <div className="col pt-3">
          <SearchBox
            value={searchQuery}
            placeholder="Search Client Name"
            onChange={handleSearch}
            clearSearch={() => {
              setSearchQuery("");
              filterPrograms("", discharged);
            }}
          />
        </div>
        <div className="col row row-cols-3 pt-3">
          <div className="col pt-3 form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="discharged"
              onChange={(e) => handleDischarged(e.currentTarget.checked)}
            />
            <label className="form-check-label" htmlFor="discharged">
              Show Discharged
            </label>
          </div>
          <div className="col">
            {safyInfo.user.modules.includes("Admin") === true ||
            safyInfo.user.safyInfo.BusinessUnitIdName === "SAFY of Colorado" ||
            safyInfo.user.safyInfo.BusinessUnitIdName === "SAFY of Nevada" ||
            safyInfo.user.safyInfo.BusinessUnitIdName === "SAFY of Alabama " ? (
              <Link id="tracking" title="Form Tracking" to="/tracking">
                <div className={"btn btn-success float-end"}>
                  Outcomes Tracking
                </div>
              </Link>
            ) : null}
          </div>
          <div className="col">
            <Link
              id="UnsignedEncounters"
              title="Open Unsigned Encounters"
              to="/unsignedencounters"
            >
              <div
                className={
                  encounters.length > 0
                    ? "btn btn-danger float-end"
                    : "btn btn-success float-end"
                }
              >
                Review Encounters{" "}
                {encounters.length > 0 ? `- ${encounters.length}` : ""}
              </div>
            </Link>
          </div>
        </div>
      </div>
      <div className="row row-cols-1 row-cols-sm-1 row-cols-md-1 row-cols-lg-2 row-cols-xl-2">
        {map(clients, (client) => (
          <ClientCard
            key={client[0]["con.contactid"]}
            client={client}
            user={safyInfo !== null && safyInfo.user}
            careplans={
              careplans &&
              careplans.filter(
                (cp) =>
                  getFieldText(cp["cp.ccx_patient"]) ===
                  client[0]["con.contactid"]
              )
            }
            history={
              history &&
              history.filter((h) =>
                client[0]["con.contactid"]
                  .toLowerCase()
                  .includes(h.ContactId.toLowerCase())
              )
            }
            onFamilyChartClick={handleFamilyChartClick}
          />
        ))}
      </div>
      {familyChart ? (
        <FamilyChartModal
          familyChart={familyChart}
          onCloseClick={() => setFamilyChart(undefined)}
        />
      ) : null}
    </>
  );
};

export default MyCaseload;
